<script>
export default {
  name: 'ReviewBox',
  props: {
    game: {
      required: true,
    },
  },
  data: () => ({
    hasRated: false,
    hasSkipped: false,
    rating: null,
    localGame: {},
    height: 0,
  }),
  created () {
    this.$nextTick(this.saveHeight);
    this.$watch('game', this.setLocalGame, { immediate: true });
  },
  methods: {
    saveHeight () {
      this.height = this.$refs.box.offsetHeight;
    },
    setLocalGame () {
      this.localGame = this.game ? { ...this.game } : this.$store.getters.unknownGame;
    },
    rate (rating) {
      this.hasRated = true;
      this.rating = rating;
      this.$emit('rate', rating);
    },
    skip () {
      this.$gtm.trackEvent({
        category: 'Game Rating',
        action: 'skip',
        label: this.localGame.title,
        game: this.localGame,
      });
      this.hasSkipped = true;
      this.setLocalGame();
      this.$emit('skip');
    },
    like () {
      this.$gtm.trackEvent({
        category: 'Game Rating',
        action: 'like',
        label: this.localGame.title,
        game: this.localGame,
      });
      this.rate(100);
    },
    dislike () {
      this.$gtm.trackEvent({
        category: 'Game Rating',
        action: 'dislike',
        label: this.localGame.title,
        game: this.localGame,
      });
      this.rate(0);
    },
  },
};
</script>

<template lang="pug">
  div.review-box.flex.flex-column.white.relative(v-show="!hasSkipped")
    .bg-black-dark-overlay._collision.overflow-hidden.relative
      button.skipbtn.f6.pa1.bg-green.absolute.top-0.right-0.h-glow.z-1.tc(type="button", @click="skip", v-if="!hasRated")
        icon.w15.fill-black(name="x")
      transition(mode="out-in", enter-active-class="animated-300 fadeInRight", leave-active-class="animated-300 fadeOutLeft")
        header.cf.pa4.ph5.flex-auto.tc(ref="box", v-if="!hasRated", key="1")
          i18n.title.fw7.f2.mv3.lh-title(path="Thank you for playing {game}", tag="h1")
            span(place="game") #[br]{{ localGame && localGame.title }}!
          h2.subtitle.f5.mv4 {{ $t('How would you rate your experience?') }}
        header.cf.pa4.ph5.flex-auto.tc.flex.items-center.justify-center(v-else, key="2", :style="{ height: `${height}px` }")
          h1.title.fw7.f2.mv3.lh-title {{ $t('Thank you!') }}
      animator(event="rate", enter-active-class="animated-500 iconanimation")
        div.animatedicon.absolute.absolute--fill.flex.items-center.justify-center.events-none.z-3.o-0
          icon.w4.fill-white.o-40.scale-x--1(:name="`thumbs-${rating ? 'up' : 'down'}`")
    transition(appear, enter-active-class="animated-300 fadeIn", leave-active-class="animated-300 fadeOut")
      div.buttons.flex.mt2(v-if="!hasRated")
        cta-style
          button.dislikebtn.b--black.pa3.w-50.mr2(type="button", @click="dislike", v-if="!hasRated")
            icon.dislikeicon.w15.v-mid.fill-white(name="thumbs-down")
        cta-style
          button.likebtn.b--black.pa3.w-50(v-sound="'progress'", type="button", @click="like", v-if="!hasRated")
            icon.likeicon.w15.v-mid.fill-white(name="thumbs-up")

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@keyframes rateAnimation {
  0% { transform: scale(0.2); opacity: 1; }
  100% { transform: scale(1); opacity: 0; }
}
.review-box {
  & .likeicon {
    transform: scaleX(-1);
    position: relative;
    top: -2px;
  }
  & >>> .iconanimation {
    animation-name: rateAnimation;
  }
}
</style>
